/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/List", "azure-devops-ui/Status", "azure-devops-ui/TooltipEx", "azure-devops-ui/Util", "azure-devops-ui/Utilities/Provider", "history", "react", "simple-query-string", "../Utils", "./PodsLeftPanel.scss"], function (require, exports, List_1, Status_1, TooltipEx_1, Util_1, Provider_1, history_1, React, queryString, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodsLeftPanel = /** @class */ (function (_super) {
        __extends(PodsLeftPanel, _super);
        function PodsLeftPanel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._onSelectionChange = function (event, tableRow) {
                _this._selectedRow = tableRow.index;
                var historyService = history_1.createBrowserHistory();
                var queryParams = queryString.parse(historyService.location.search);
                var selectedView = queryParams["view"];
                if (_this.props.onSelectionChange) {
                    _this.props.onSelectionChange(event, _this.props.pods[tableRow.index], (typeof selectedView === "string") ? selectedView : "");
                }
            };
            _this._renderListRow = function (index, pod, details, key) {
                var _a = Utils_1.Utils.generatePodStatusProps(pod.status), statusProps = _a.statusProps, tooltip = _a.tooltip;
                var rowClassName = index === 0 ? Util_1.css("pods-left-panel-row", "first-row") : "pods-left-panel-row";
                var textClassName = Util_1.css("primary-text text-ellipsis body-m", index === _this._selectedRow ? "font-weight-semibold" : "");
                return (React.createElement(List_1.ListItem, { className: rowClassName, key: key || "list-item" + index, index: index, details: details },
                    React.createElement("div", { className: "pod-text-status-container flex-row flex-center h-scroll-hidden" },
                        React.createElement("div", { className: "pod-noshrink flex-noshrink" }),
                        React.createElement("div", { className: "pod-shrink flex-row flex-center flex-shrink" },
                            statusProps &&
                                React.createElement(TooltipEx_1.Tooltip, { text: tooltip },
                                    React.createElement("div", { className: "flex-row" },
                                        React.createElement(Status_1.Status, __assign({}, statusProps, { ariaLabel: tooltip, className: "icon-large-margin", size: "16" /* m */ })))),
                            React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true, text: pod.metadata.name },
                                React.createElement("div", { className: textClassName }, pod.metadata.name))))));
            };
            _this._selection = new List_1.ListSelection({ selectOnFocus: true });
            _this._hasSelected = false;
            _this._selectedRow = -1;
            return _this;
        }
        PodsLeftPanel.prototype.render = function () {
            return (this.props.pods && this.props.pods.length > 0 ?
                React.createElement(List_1.List, { itemProvider: new Provider_1.ArrayItemProvider(this.props.pods), onSelect: this._onSelectionChange, selection: this._selection, renderRow: this._renderListRow, width: "100%" })
                : null);
        };
        PodsLeftPanel.prototype.componentDidMount = function () {
            if (this.props.pods && this.props.pods.length) {
                this._selectPod();
            }
        };
        PodsLeftPanel.prototype.componentDidUpdate = function (prevProps) {
            if (!(prevProps.pods && prevProps.pods.length) && (this.props.pods && this.props.pods.length)) {
                this._selectPod();
            }
        };
        PodsLeftPanel.prototype._selectPod = function () {
            var selectedPodName = this.props.selectedPodName;
            if (!this._hasSelected) {
                if (selectedPodName) {
                    this._selectedRow = (this.props.pods || []).findIndex(function (pod) { return pod.metadata.name === selectedPodName; });
                }
                if (this._selectedRow === -1 || this._selectedRow >= (this.props.pods || []).length) {
                    this._selectedRow = 0;
                }
                // select the first pod in left panel by default
                this._selection.select(this._selectedRow);
                this._hasSelected = true;
            }
        };
        return PodsLeftPanel;
    }(React.Component));
    exports.PodsLeftPanel = PodsLeftPanel;
});
